export default "__VITE_ASSET__7c671c2b__"